<template>
  <div>
    <h3>Тип черги</h3>

    <b-form-select
      class="queue-type d-block mb-2 w-100"
      v-model="selectedTable"
    >
      <b-form-select-option
        :value="o.value"
        v-for="o in filterOptions"
        :key="o.value"
      >
        {{ o.text }}
      </b-form-select-option>
    </b-form-select>
    <p class="mb-4">
      Ви також можете подати заявку для того аби стати в чергу на безкоштовне
      житло, скориставшись послугою
      <router-link
        :to="{
          name: 'service-single-local',
          params: { slug: 'dwelling-queue-application' },
        }"
        >Подати заявку на чергу на житло</router-link
      >
    </p>

    <b-overlay spinner-variant="warning" :show="isLoading">
      <dwellingQueueTable :key="filteredRows.length" :rowData="filteredRows" />
    </b-overlay>
  </div>
</template>

<script>
import dwellingQueueTable from "@/components/local-services/sub-components/dwelling-queue-table.vue";
export default {
  components: {
    dwellingQueueTable,
  },
  data() {
    return {
      isLoading: false,
      rowData: [],
      selectedTable: 0,
    };
  },
  computed: {
    filteredRows() {
      let data = this.rowData;
      let selected = this.selectedTable;
      switch (selected) {
        case 0:
          // All
          break;
        case "general":
          data = data.filter(
            (item) => item.privilege && item.privilege.length <= 2
          );
          break;
        case "впо":
          data = data.filter(
            (item) =>
              item.privilege && item.privilege.toLowerCase().includes("впо")
          );
          break;
        case "priv":
          data = data.filter(
            (item) => item.privilege && item.privilege.length > 2
          );
          break;
      }

      return data;
    },
    filterOptions() {
      let options = [
        { value: 0, text: "Всі" },
        { value: "general", text: "Загальна" },
        { value: "впо", text: "ВПО" },
        { value: "priv", text: "Пільгова" },
      ];
      return options;
    },
  },

  methods: {
    async getListData() {
      this.isLoading = true;
      var data = await this.$api
        .get("/getDwellingQue")
        .then((data) => {
          return data.data.data;
        })
        .catch(() => {
          this.$toast.error("Сталася помилка");
        });
      this.isLoading = false;
      let formattedData = data.map((item) => {
        return {
          number: item.number,
          name: item.name,
          privilege: item.privilege !== "null" ? item.privilege : "--",
        };
      });
      this.rowData = formattedData;
    },
  },
  async mounted() {
    await this.getListData();
  },
};
</script>

ls
<style lang="scss" scoped>
.queue-type {
  height: 32px;
  padding: 0px 6px;
}
</style>
